
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { ShiftModel, ShiftStateEnum } from '@/libs/Api';

@Component({})
export default class LocationShiftDetail extends Page {
    @Prop({ required: true }) shift!: ShiftModel;
    protected ShiftStateEnum: typeof ShiftStateEnum = ShiftStateEnum;
}
